import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { CalculatorsStudentLoanStep1FormFields } from '../../../../../@types/features/calculators';

export const calculatorStudentLoanStep1FormFields: Record<
  keyof CalculatorsStudentLoanStep1FormFields,
  FormInput
> = {
  studentDebtAmount: {
    fieldName: 'studentDebtAmount',
    label: 'Hoeveel betaal je maandelijks aan de aflossing van de studieschuld, inclusief rente?',
    type: 'currency',
    required: true,
    placeHolder: '€ 150',
    removeDecimals: true,
    defaultValue: getDefaultValue('150'),
    hint: 'Weet je de maandelijkse aflossing niet? Dit kun je vinden op <a href="https://www.duo.nl/particulier/inloggen-op-mijn-duo.jsp" target="_blank">Mijn DUO</a>. Als je nog niet aflost, doe dan op <a href="https://duo.nl/particulier/rekenhulp-studiefinanciering.jsp#/nl/terugbetalen/start" target="_blank">duo.nl</a> de proefberekening om je maandlast in te schatten.'
  },
  withPartner: {
    fieldName: 'withPartner',
    label: 'Wil je alleen of samen kopen?',
    type: 'radio',
    options: [
      { label: 'Alleen', value: 'false' },
      { label: 'Samen', value: 'true' }
    ],
    defaultValue: getDefaultValue('false', true)
  },
  partnerStudentDebtAmount: {
    fieldName: 'partnerStudentDebtAmount',
    label:
      'Hoeveel betaalt je partner aan de aflossing van zijn/haar eventuele studieschuld, inclusief rente?',
    type: 'currency',
    required: true,
    placeHolder: '€ 100',
    removeDecimals: true,
    defaultValue: getDefaultValue('18000')
  }
};
